import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgFinanceReportIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g fill="currentColor">
      <path d="M25.6 60.8h25.6a3.2 3.2 0 0 0 3.2-3.2V32h-3.2v25.6H25.6z" />
      <path d="m41.6 6.4.064.064L41.6 48l-28.8-.064.064-41.536zm0-3.2H12.864A3.264 3.264 0 0 0 9.6 6.464v41.472a3.264 3.264 0 0 0 3.264 3.264H41.6a3.264 3.264 0 0 0 3.264-3.264V6.464A3.264 3.264 0 0 0 41.6 3.2" />
      <path d="M25.887 12.8v4.295h-2.864a2.863 2.863 0 0 0-2.863 2.863v5.726a2.863 2.863 0 0 0 2.863 2.863h8.59v5.727H20.16v2.863h5.727v4.295h2.863v-4.295h2.863a2.863 2.863 0 0 0 2.863-2.863v-5.727a2.863 2.863 0 0 0-2.863-2.863h-8.59v-5.726h11.453v-2.863H28.75V12.8z" />
    </g>
  </svg>
)
export default SvgFinanceReportIcon
